import { batch } from 'react-redux'
import postLogin from '../../../axios/registration/auth/login/post'
import { setLoginInvalidIndexError, setLoginInvalidPasswordError, setLoginLoading } from '../../../action'
import postLogout from '../../../axios/registration/auth/logout/post'
import getAuthentication from '../../../axios/registration/auth/authentication/get'
import { setAppErrors } from '../../../action/system'
import { retrieveErrorFromApi } from '../../../../helper'
import { disconnectSocketThunk } from '../../socket'
import { redirectByUserType, redirectToLogin } from './helper'
import { getLocalStorageRefreshToken, setLocalStorageAccessToken, setLocalStorageRefreshToken } from '../../../../helper/clientMonitor'
import { getCookieRefreshToken, setCookieTokens } from '../../../../helper/cookieToken'
import { isLocalStorageMobileAppMode } from '../../../../helper/mode'
import { logger } from '../../../../logger/logger'
import { getNotificationDeviceThunk } from '../../notificationsDevices'
import { setLoginFailedWithStorageThunk, setLogoutWithStorageThunk } from './withStorage'
import { localStorageApi } from '../../../../helper/localStorageApi'
import fetchUser from '../../../axios/registration/user/get'
import { buildCredentialsKey, buildCredentialsBlob, publishLoginSucceeded } from '../../../../helper/savedCredentials'

export const postLoginThunk = (email, companyIndex, password, recaptchaValue) => dispatch => {
	return postLogin({ email, companyIndex, password, recaptchaValue })
		.then(res => {
			const accessToken = res.data.accessToken
			const refreshToken = res.data.refreshToken
			if (!accessToken || !refreshToken) {
				dispatch(setLoginFailedWithStorageThunk())
				return
			}

			if (email) localStorageApi.setItem('login', email)
			if (companyIndex) localStorageApi.setItem('companyIndex', companyIndex)
			setLocalStorageAccessToken(accessToken)
			setLocalStorageRefreshToken(refreshToken)
			if (res.data.user?.group !== 'KIOSK') {
				setCookieTokens(accessToken, refreshToken)
			}
			publishLoginSucceeded(buildCredentialsKey(companyIndex, email), buildCredentialsBlob(password))
			redirectByUserType({ user: res.data.user, accessToken, refreshToken })
		}).catch(error => {
			dispatch(setLoginLoading(false))
			dispatch(setLoginFailedWithStorageThunk())
			if (error.response.status === 401 || error.response.status === 404) {
				dispatch(setLoginInvalidPasswordError(true))
			} else if (error.response.status === 400) {
				dispatch(setLoginInvalidIndexError(true))
			} else {
				dispatch(setAppErrors(retrieveErrorFromApi(error)))
			}
		})
}

export const postLogoutThunk = () => {
	const refreshToken = getCookieRefreshToken() || getLocalStorageRefreshToken()

	return (dispatch) => {
		dispatch(postLogout(refreshToken,
			res => {
				new Promise((resolve, reject) => {
					batch(() => {
						// Sockets disconnection:
						dispatch(disconnectSocketThunk())
					})
					resolve()
				}).then(() => {
					redirectToLogin()
					dispatch(setLogoutWithStorageThunk())
				})
			},
			error => {
				dispatch(setAppErrors(retrieveErrorFromApi(error)))
				new Promise((resolve, reject) => {
					batch(() => {
						// Sockets disconnection:
						dispatch(disconnectSocketThunk())
					})
					resolve()
				}).then(() => {
					redirectToLogin()
					dispatch(setLogoutWithStorageThunk())
				})
			}))
	}
}

export const getAuthenticationThunk = () => async dispatch => {
	logger.info('[socket-io] Try to re-authenticate socket')
	try {
		const res = await getAuthentication()
		return res.data.jwt
	} catch (error) {
		logger.info('[socket-io] Error while socket re-authentication')
		throw error
	}
}

export const redirectLoggedInUserThunk = () => (dispatch, getState) => {
	const accessToken = getState().core?.auth?.accessToken
	const refreshToken = getCookieRefreshToken() || getLocalStorageRefreshToken()
	if (!accessToken || !refreshToken) {
		dispatch(setLogoutWithStorageThunk())
		return
	}

	return fetchUser()
		.then(res => {
			redirectByUserType({ user: res.data, accessToken, refreshToken })
		}).catch(() => {
			dispatch(setLogoutWithStorageThunk())
		})
}

export const appNotificationDeviceThunk = (index, username) => dispatch => {
	const companyIndex = index?.toUpperCase()
	const isMobileApp = isLocalStorageMobileAppMode()
	const appNotificationData = localStorageApi.getItem('appNotificationData')
	const deviceId = appNotificationData?.deviceId
	const token = appNotificationData?.expoPushToken
	logger.info(`Get native appNotification device:${deviceId}, token:${token}, companyIndex:${companyIndex}, isMobileApp:${isMobileApp}`)
	if (isMobileApp && deviceId) {
		logger.info('Started get notification device')
		return dispatch(getNotificationDeviceThunk(username, deviceId, token))
	}
}
